var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoGray = function SvgInfoGray(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#d8d8d8",
    height: 16,
    opacity: 0.4,
    rx: 3,
    width: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.993 4c.292 0 .53.081.716.27A.955.955 0 0 1 9 4.986c0 .298-.106.541-.291.73A1 1 0 0 1 7.993 6a.949.949 0 0 1-.702-.284C7.093 5.527 7 5.284 7 4.986c0-.297.093-.54.278-.716.186-.189.424-.27.715-.27zM7 7h2v5H7z",
    clipRule: "evenodd",
    fill: "#acacac",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoGray);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCBmaWxsPSIjZDhkOGQ4IiBoZWlnaHQ9IjE2IiBvcGFjaXR5PSIuNCIgcng9IjMiIHdpZHRoPSIxNiIvPjxwYXRoIGQ9Ik03Ljk5MyA0Yy4yOTIgMCAuNTMuMDgxLjcxNi4yN0EuOTU1Ljk1NSAwIDAgMSA5IDQuOTg2YzAgLjI5OC0uMTA2LjU0MS0uMjkxLjczQTEgMSAwIDAgMSA3Ljk5MyA2YS45NDkuOTQ5IDAgMCAxLS43MDItLjI4NEM3LjA5MyA1LjUyNyA3IDUuMjg0IDcgNC45ODZjMC0uMjk3LjA5My0uNTQuMjc4LS43MTYuMTg2LS4xODkuNDI0LS4yNy43MTUtLjI3ek03IDdoMnY1SDd6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNhY2FjYWMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";